import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import { SearchParams, SearchResponse } from "./types";

export * from "./types";

const ENDPOINTS = {
  SEARCH: "/api/v2/org/:organization_id/user/:user_id/search",
};

export class SearchAPI {
  constructor(private client: CohesiveAPIClient) {}

  /**
   * Global search across workspaces, canvases, chats, files, and folders the
   * user can view. Results come back grouped by type with per-type limits.
   */
  async global(
    params: SearchParams,
    config?: AxiosRequestConfig,
  ): Promise<SearchResponse> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    // Serialized by hand: the backend reads repeated `type=` params, while axios's
    // default serializer would emit `type[]=`.
    const query = new URLSearchParams({ q: params.q });
    for (const type of params.types ?? []) {
      query.append("type", type);
    }
    if (params.limit !== undefined) {
      query.set("limit", String(params.limit));
    }

    const path = route(ENDPOINTS.SEARCH, {
      organization_id: organizationId,
      user_id: userId,
    });

    const response = await this.client.axios.get<{ data: SearchResponse }>(
      `${path}?${query.toString()}`,
      config,
    );
    return response.data.data;
  }
}
